// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"de124143","546":"ec717778","787":"b59edec7","968":"96262042"}[chunkId] + ".chunk.js";
};